import Form from "~~/entities/PrizificPageBuilder/components/Form";
import { emailFormItem } from "./EmailFormItem";
import { passwordFormItem } from "./PasswordFormItem";

export const userConsentLoginForm = new Form("-", "Login form", [], "", [
    emailFormItem,
    passwordFormItem,
]);
